const products_path = 'products/products/'

// Anterior:
//const salecart = ({ opt = {} }) => axios.get('salecart/', opt)
// cambio a:
const salecart = ({ opt = {} }) => axios.get(products_path, opt)
const purchasecart = ({ opt = {} }) => axios.get('products/purchasecart/', opt)
const list = ({ opt = {} }) => axios.get(products_path, opt)
const create = ({ form, opt = {} }) => axios.post(products_path, form, opt)
const nextCode = ({ opt = {} } = {}) =>
  axios.get(`${products_path}next-code/`, opt)
const edit = ({ pk, form, opt = {} }) =>
  axios.put(`${products_path}${pk}/`, form, opt)
const show = ({ pk, opt = {} }) => axios.get(`${products_path}${pk}/`, opt)
const remove = ({ pk }) => axios.delete(`${products_path}${pk}/`)
const pricescreate = ({ opt = {} }) => axios.get('products/pricesCreate/', opt)
const favorite = ({ pk, form, opt = {} }) =>
  axios.patch(`${products_path}${pk}/update-favorite/`, form, opt)

// Extra values
const template_path = 'products/template/'
const template = {
  list: ({ opt = {} }) => axios.get(template_path, opt),
  create: ({ form, opt = {} }) => axios.post(template_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${template_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${template_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${template_path}${pk}/`)
}

const sustrate_path = 'products/sustrate/'
const sustrate = {
  list: ({ opt = {} }) => axios.get(sustrate_path, opt),
  create: ({ form, opt = {} }) => axios.post(sustrate_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${sustrate_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${sustrate_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${sustrate_path}${pk}/`)
}

const measure_path = 'products/productMeasure/'
const measure = {
  list: ({ opt = {} }) => axios.get(measure_path, opt),
  create: ({ form, opt = {} }) => axios.post(measure_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${measure_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${measure_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${measure_path}${pk}/`)
}

const prices_path = 'products/productprices/'
const prices = {
  list: ({ opt = {} }) => axios.get(prices_path, opt),
  create: ({ form, opt = {} }) => axios.post(prices_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${prices_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${prices_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${prices_path}${pk}/`)
}

const extracost_path = 'products/extracost/'
const extracost = {
  list: ({ opt = {} }) => axios.get(extracost_path, opt),
  create: ({ form, opt = {} }) => axios.post(extracost_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${extracost_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${extracost_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${extracost_path}${pk}/`)
}

const details_path = 'products/production/'
const details = {
  list: ({ opt = {} }) => axios.get(details_path, opt),
  create: ({ form, opt = {} }) => axios.post(details_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${details_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${details_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${details_path}${pk}/`)
}

const subdetails_path = 'products/production-subitem/'
const subdetails = {
  list: ({ opt = {} }) => axios.get(subdetails_path, opt),
  create: ({ form, opt = {} }) => axios.post(subdetails_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${subdetails_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${subdetails_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${subdetails_path}${pk}/`)
}

const processitem_path = 'products/process/'
const processitem = {
  list: ({ opt = {} }) => axios.get(processitem_path, opt),
  create: ({ form, opt = {} }) => axios.post(processitem_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${processitem_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${processitem_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${processitem_path}${pk}/`)
}

const processsubitem_path = 'products/process-subitems/'
const processsubitem = {
  list: ({ opt = {} }) => axios.get(processsubitem_path, opt),
  create: ({ form, opt = {} }) => axios.post(processsubitem_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${processsubitem_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${processsubitem_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${processsubitem_path}${pk}/`)
}

const processprices_path = 'products/processprices/'
const processprices = {
  list: ({ opt = {} }) => axios.get(processprices_path, opt),
  create: ({ form, opt = {} }) => axios.post(processprices_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${processprices_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${processprices_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${processprices_path}${pk}/`)
}

const apparelcolor_path = 'products/apparel-colors/'
const apparelcolor = {
  list: ({ opt = {} }) => axios.get(apparelcolor_path, opt),
  create: ({ form, opt = {} }) => axios.post(apparelcolor_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${apparelcolor_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${apparelcolor_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${apparelcolor_path}${pk}/`),
  clone: ({ form, opt = {} }) =>
    axios.post(`${apparelcolor_path}clone/`, form, opt)
}

const apparel_name_path = 'products/apparels/'
const apparelName = {
  list: ({ opt = {} }) => axios.get(apparel_name_path, opt),
  create: ({ form, opt = {} }) => axios.post(apparel_name_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${apparel_name_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${apparel_name_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${apparel_name_path}${pk}/`),
  clone: ({ form, opt = {} }) =>
    axios.post(`${apparel_name_path}clone/`, form, opt)
}

const apparel_style_path = 'products/apparel-styles/'
const apparelStyle = {
  list: ({ opt = {} }) => axios.get(apparel_style_path, opt),
  create: ({ form, opt = {} }) => axios.post(apparel_style_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${apparel_style_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${apparel_style_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${apparel_style_path}${pk}/`),
  clone: ({ form, opt = {} }) =>
    axios.post(`${apparel_style_path}clone/`, form, opt)
}

const fabric_type_path = 'products/fabric-types/'
const fabricType = {
  list: ({ opt = {} }) => axios.get(fabric_type_path, opt),
  create: ({ form, opt = {} }) => axios.post(fabric_type_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${fabric_type_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${fabric_type_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${fabric_type_path}${pk}/`),
  clone: ({ form, opt = {} }) =>
    axios.post(`${fabric_type_path}clone/`, form, opt)
}

const apparel_brand_path = 'products/apparel-brands/'
const apparelBrand = {
  list: ({ opt = {} }) => axios.get(apparel_brand_path, opt),
  create: ({ form, opt = {} }) => axios.post(apparel_brand_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${apparel_brand_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${apparel_brand_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${apparel_brand_path}${pk}/`),
  clone: ({ form, opt = {} }) =>
    axios.post(`${apparel_brand_path}clone/`, form, opt)
}

const apparel_gender_path = 'products/apparel-genders/'
const apparelGender = {
  list: ({ opt = {} }) => axios.get(apparel_gender_path, opt),
  create: ({ form, opt = {} }) => axios.post(apparel_gender_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${apparel_gender_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${apparel_gender_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${apparel_gender_path}${pk}/`),
  clone: ({ form, opt = {} }) =>
    axios.post(`${apparel_gender_path}clone/`, form, opt)
}

export default {
  list,
  create,
  nextCode,
  edit,
  show,
  remove,
  favorite,
  salecart,
  purchasecart,
  pricescreate,
  template,
  sustrate,
  measure,
  prices,
  extracost,
  details,
  subdetails,
  processitem,
  processsubitem,
  processprices,
  apparelcolor,
  apparelName,
  apparelStyle,
  fabricType,
  apparelBrand,
  apparelGender
}
